'use client';
import { useMountEffect } from '@/hooks/useMountEffect';
import { PAGES } from '@/constants/pages';
import { classes } from './utils';

export default function NotFound() {
  useMountEffect(() => {
    window.location.assign(PAGES.DASHBOARD);
  });

  return <div className={classes.notFound}>Redirecting...</div>;
}
